module.exports = __webpack_public_path__ + "img/loading.4ba61248.gif";